import { concat } from "@ember/helper";
import { computed } from "@ember/object";
import { isEmpty } from "@ember/utils";
import { classNames } from "@ember-decorators/component";
import componentForCollection from "discourse/helpers/component-for-collection";
import SelectKitComponent, {
  pluginApiIdentifiers,
  resolveComponent,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import SelectKitBody from "discourse/select-kit/components/select-kit/select-kit-body";
import { isNumeric } from "discourse/select-kit/lib/input-utils";
import { i18n } from "discourse-i18n";
import SingleSelectHeader from "./select-kit/single-select-header.gjs";

@classNames("single-select")
@selectKitOptions({
  headerComponent: SingleSelectHeader,
})
@pluginApiIdentifiers(["single-select"])
export default class SingleSelect extends SelectKitComponent {
  singleSelect = true;

  @computed("value", "content.[]", "selectKit.noneItem")
  get selectedContent() {
    if (!isEmpty(this.value)) {
      let content;

      const value =
        this.selectKit.options.castInteger && isNumeric(this.value)
          ? Number(this.value)
          : this.value;

      if (this.selectKit.valueProperty) {
        content = (this.content || []).find(
          (item) => item[this.selectKit.valueProperty] === value
        );

        return this.selectKit.modifySelection(
          content || this.defaultItem(value, value)
        );
      } else {
        return this.selectKit.modifySelection(
          (this.content || []).filter((c) => c === value)
        );
      }
    } else {
      if (this.value === "" && this.selectKit.valueProperty) {
        const blankItem = (this.content || []).find(
          (item) => item[this.selectKit.valueProperty] === ""
        );

        if (blankItem) {
          return this.selectKit.modifySelection(blankItem);
        }
      }

      return this.selectKit.noneItem;
    }
  }

  <template>
    {{#unless this.selectKit.isHidden}}
      {{#let
        (resolveComponent this this.selectKit.options.headerComponent)
        as |HeaderComponent|
      }}
        <HeaderComponent
          @id={{concat this.selectKit.uniqueID "-header"}}
          @selectedContent={{this.selectedContent}}
          @selectKit={{this.selectKit}}
          @tabindex={{this.tabindex}}
          @value={{this.value}}
        />
      {{/let}}

      <SelectKitBody
        @id={{concat this.selectKit.uniqueID "-body"}}
        @selectKit={{this.selectKit}}
      >
        {{#let
          (resolveComponent this this.selectKit.options.filterComponent)
          as |FilterComponent|
        }}
          <FilterComponent
            @id={{concat this.selectKit.uniqueID "-filter"}}
            @selectKit={{this.selectKit}}
          />
        {{/let}}

        {{#each this.collections as |collection|}}
          {{#let
            (resolveComponent
              this (componentForCollection collection.identifier this.selectKit)
            )
            as |CollectionComponent|
          }}
            <CollectionComponent
              @collection={{collection}}
              @selectKit={{this.selectKit}}
              @value={{this.value}}
            />
          {{/let}}
        {{/each}}

        {{#if this.selectKit.filter}}
          {{#if
            (and this.selectKit.hasNoContent (not this.selectKit.isLoading))
          }}
            <span class="no-content" role="alert">
              {{i18n "select_kit.no_content"}}
            </span>
          {{else}}
            <span class="results-count" role="alert">
              {{i18n
                "select_kit.results_count"
                count=this.mainCollection.length
              }}
            </span>
          {{/if}}
        {{/if}}

      </SelectKitBody>
    {{/unless}}
  </template>
}
